module.exports = __webpack_public_path__ + "img/C4 INTENSITY SERIES.fa261899.png";